import { useId } from 'react';
import { cn } from '../../utils/cn';

const VIEWBOX_SIZE = 80;
const RING_CLIP_PATH =
    'M39.746 79.4921C61.6972 79.4921 79.4921 61.6972 79.4921 39.746C79.4921 17.7949 61.6972 0 39.746 0C17.7949 0 0 17.7949 0 39.746C0 61.6972 17.7949 79.4921 39.746 79.4921ZM39.746 11.8851C55.1332 11.8851 67.607 24.3589 67.607 39.746C67.607 55.1332 55.1332 67.607 39.746 67.607C24.3589 67.607 11.8851 55.1332 11.8851 39.746C11.8851 24.3589 24.3589 11.8851 39.746 11.8851Z';
const RING_GRADIENT =
    'conic-gradient(from 90deg, rgba(10, 100, 200, 1) 0deg, rgba(10, 100, 200, 1) 63.243deg, rgba(255, 255, 255, 0) 360deg)';

type LoadingSpinnerProps = {
    size?: number;
    className?: string;
};

export default function LoadingSpinner({ size = VIEWBOX_SIZE, className }: LoadingSpinnerProps) {
    const clipPathId = useId().replace(/:/g, '');

    return (
        <svg
            width={size}
            height={size}
            viewBox={`0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={cn('shrink-0', className)}
            aria-hidden
        >
            <defs>
                <clipPath id={clipPathId}>
                    <path d={RING_CLIP_PATH} />
                </clipPath>
            </defs>
            <g clipPath={`url(#${clipPathId})`}>
                <foreignObject x='0' y='0' width={VIEWBOX_SIZE} height={VIEWBOX_SIZE}>
                    <div
                        {...({ xmlns: 'http://www.w3.org/1999/xhtml' } as Record<string, string>)}
                        style={{
                            width: '100%',
                            height: '100%',
                            background: RING_GRADIENT,
                        }}
                    />
                </foreignObject>
            </g>
            <circle
                cx='5.96191'
                cy='5.96191'
                r='5.96191'
                transform='matrix(0 1 1 0 67.5703 34.1816)'
                fill='#0A64C8'
            />
        </svg>
    );
}
